import { render, staticRenderFns } from "./RanksAgeAverage.vue?vue&type=template&id=191ac523&scoped=true&"
import script from "./RanksAgeAverage.vue?vue&type=script&lang=js&"
export * from "./RanksAgeAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191ac523",
  null
  
)

export default component.exports